import styled, { css } from 'styled-components';
import { mq, getGridSpan, borderShape, getSpace } from '../../../stylesheets/tools';

const StyledInfobox = styled.aside`
  position: relative;
  width: ${getGridSpan(11)};
  margin-bottom: ${getSpace('xxl')};
  margin-left: ${getGridSpan(1, 'spread')};

  ${mq('m')} {
    width: ${getGridSpan(5)};

    ${props =>
      props.alignment === 'left' &&
      css`
        float: left;
        margin-left: ${props.wide ? 0 : getGridSpan(1, 'spread')};
        margin-right: ${getGridSpan(1, 'full')};
      `}

    ${props =>
      props.alignment === 'right' &&
      css`
        float: right;
        margin-right: ${props.wide ? 0 : getGridSpan(1, 'spread')};
        margin-left: ${getGridSpan(1, 'full')};
      `}
  }

  ${mq('l')} {
    width: ${props => (props.wide ? getGridSpan(5) : getGridSpan(4))};
  }

  .infobox__content-wrapper {
    position: relative;
    width: 100%;
    background: #fff;
  }

  .infobox__content {
    padding: ${getSpace('l')} ${getSpace('m')};
    ${borderShape()}

    ${props =>
      props.theme.siteTheme &&
      css`
        ${borderShape(props.theme.siteTheme.borderColor)}
      `}
  }

  .infobox__background {
    position: absolute;
    width: calc(100% - 30px);
    height: 100%;
    margin: 20px 20px 20px 60px;
    border: 2px solid #000;

    ${mq('m')} {
      width: 100%;
      margin: 20px;
    }
  }

  .infobox__headline {
    margin: 0 0 ${getSpace('s')};
  }

  ol,
  ul {
    width: 100%;
    margin: ${getSpace('s')} 0 0;
  }

  @media print {
    margin: 0;

    .infobox__content {
      background: transparent;
      border: 2px solid black;
    }

    .infobox__background {
      display: none;
    }
  }
`;

export default StyledInfobox;
